
import axios from 'axios'
import env from './config/env'

window.axios = axios

window.axios.defaults.withCredentials = true
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['Accept'] = 'application/json'
window.axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
window.axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

// Base URL for Sanctum CSRF (API root, not /api/v1)
window.axios.defaults.baseURL = env.normalURL

window._ = require('lodash')



// WEBPACK FOOTER //
// ./src/bootstrap.js